import { AutoCompleteResponse, ResponseStatus } from "models/Company";
import { IApiClient } from "./ApiClient";

export interface IAutoCompleteService {
    autoCompleteAddress(id: string): Promise<AutoCompleteResponse | undefined>;
  }

  export default class AutoCompleteService implements IAutoCompleteService{

    apiBase: string;
    apiClient: IApiClient;

    constructor(apiClient: IApiClient) {
        this.apiBase = '/api/autocomplete';
        this.apiClient = apiClient;
      }

    async autoCompleteAddress(query:string){
        try {
            const response = await this.apiClient.get<AutoCompleteResponse>(`${this.apiBase}/address/${query}`);
            return response ? response : undefined;
          } catch (exception) {
            console.error(exception);
          }
    }
  }